import { Icon, IconProps } from '@material-ui/core';
import React from 'react';

export const ArrowRightIcon = (props: IconProps) => <Icon {...props}>arrow_right</Icon>;
